import { Apollo } from 'apollo-angular';
import { Inject, Injectable, LOCALE_ID, TransferState, makeStateKey } from '@angular/core';

import { map, switchMap, take, catchError } from 'rxjs/operators';
import { FRONT_PAGE_GAMES_DESKTOP_QUERY, FRONT_PAGE_GAMES_QUERY } from '../../apollo/front-page-games/front-page-games';
import { FrontPageGamesResponse } from '../../apollo/models/base-models';
import { BehaviorSubject, Observable } from 'rxjs';
import { countryFromLocale } from 'src/app/utils/country-from-locale';
import { LICENCE } from 'src/app/global.tokens';
import { DetectDeviceService } from '../utils/detect-device.service';
import { ClonerService } from '../utils/clone-object.service';

@Injectable({
    providedIn: 'root'
})
export class FrontPageGamesService {

    constructor(
        private apollo: Apollo,
        public detectDeviceService: DetectDeviceService,
        private cloneService: ClonerService,
        @Inject(LOCALE_ID) public locale: string,
        @Inject(LICENCE) public licence: string,
        private transferState: TransferState
    ) { }

    private _response = new BehaviorSubject<FrontPageGamesResponse>(null);


    fetchData(): Observable<FrontPageGamesResponse> {
        const FRONT_PAGE_GAMES_FETCH_HAS_ERROR = makeStateKey<any>('front-page-games-fetch-has-error');
        if (this._response.value) {
            return this._response.asObservable();
        }
        else {
            if (this.transferState.get(FRONT_PAGE_GAMES_FETCH_HAS_ERROR, null)) {
              throw new Error("Error fetching data. ");
            }
            const query = this.detectDeviceService.isDesktop() ? FRONT_PAGE_GAMES_DESKTOP_QUERY : FRONT_PAGE_GAMES_QUERY;
            return this.apollo
                .watchQuery<FrontPageGamesResponse>({
                    query: query,
                    variables: {
                        licenseName: this.licence,
                        locale: this.locale,
                        countryName: [countryFromLocale(this.locale)]
                    },
                    errorPolicy: 'all'
                })
                .valueChanges.pipe(
                    take(1),
                    map(resp => {
                        let frontPageGames = this.cloneService.deepClone<FrontPageGamesResponse>(resp.data);
                        frontPageGames.pagesCategories = frontPageGames.pagesCategories.filter(item => !!item.licence.find(licence => licence === this.licence) || !!item.licence.find(licence => licence === 'all'))
                        return frontPageGames
                    }),
                    switchMap((response) => {
                        this._response.next(response);
                        return this._response.asObservable();
                    }
                    ),
                    catchError(error => {
                        console.error('Error fetching data:', error);
                        this.transferState.set(FRONT_PAGE_GAMES_FETCH_HAS_ERROR, true);
                        return this._response.asObservable();
                    })
                );
        }
    }
}
